var _clipPath, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtifyLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    height: 65,
    viewBox: "0 0 213 65",
    width: 213,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h53v60h-53z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.3333 3.66667v26.66663m0 26.6667v-26.6667m18.8562-18.8561-37.7124 37.7123m18.8562-18.8562h-26.66664m45.52284 18.8562-37.7124-37.7123",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m65.605 52 14.41-40.975h8.03l14.41 40.975h-6.93l-3.135-9.185h-16.665l-3.19 9.185zm11.99-14.96h12.815l-7.26-21.45h1.815zm29.116 14.96v-29.755h5.94v5.995l-.55-.88c.66-1.9433 1.723-3.3367 3.19-4.18 1.467-.88 3.227-1.32 5.28-1.32h1.815v5.665h-2.585c-2.053 0-3.722.6417-5.005 1.925-1.247 1.2467-1.87 3.0433-1.87 5.39v17.16zm33.334.33c-3.117 0-5.537-.88-7.26-2.64s-2.585-4.235-2.585-7.425v-14.41h-5.225v-5.61h.825c1.393 0 2.475-.4033 3.245-1.21s1.155-1.9067 1.155-3.3v-2.31h6.215v6.82h6.765v5.61h-6.765v14.135c0 1.0267.165 1.9067.495 2.64.33.6967.862 1.2467 1.595 1.65.733.3667 1.687.55 2.86.55.293 0 .623-.0183.99-.055s.715-.0733 1.045-.11v5.335c-.513.0733-1.082.1467-1.705.22s-1.173.11-1.65.11zm9.42-.33v-29.755h6.215v29.755zm0-33.825v-7.15h6.215v7.15zm16.836 33.825v-24.145h-5.5v-5.61h5.5v-1.54c0-2.2367.459-4.1067 1.375-5.61.917-1.54 2.182-2.7133 3.795-3.52 1.65-.8067 3.539-1.21 5.665-1.21.404 0 .862.0367 1.375.11.514.0367.935.0917 1.265.165v5.39c-.293-.0733-.623-.11-.99-.11-.366-.0367-.66-.055-.88-.055-1.65 0-2.97.385-3.96 1.155-.99.7333-1.485 1.9617-1.485 3.685v1.54h6.82v5.61h-6.82v24.145zm21.414 12.155c-.733 0-1.466-.0733-2.2-.22-.696-.11-1.338-.2933-1.925-.55v-5.335c.44.11.972.2017 1.595.275.624.11 1.229.165 1.815.165 1.724 0 2.989-.385 3.795-1.155.844-.7333 1.595-1.8883 2.255-3.465l1.98-4.51-.11 5.225-12.87-32.34h6.655l9.515 24.805h-2.255l9.46-24.805h6.71l-13.145 33c-.696 1.76-1.576 3.3-2.64 4.62-1.026 1.3567-2.255 2.4017-3.685 3.135-1.393.77-3.043 1.155-4.95 1.155z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtifyLogoDark);
export default __webpack_public_path__ + "static/media/artify-logo-dark.9f820db497afe3c1af145402fbf7e409.svg";
export { ForwardRef as ReactComponent };